import React from 'react';
import { Form } from 'react-bootstrap';
import { Product } from 'lib/types';

interface AdditionsDisplayProps {
    selectedProduct: Product;
    selectedAdditions: boolean[];
    setSelectedAdditions: React.Dispatch<React.SetStateAction<boolean[]>>;
}

const AdditionsDisplay = ({ selectedProduct, selectedAdditions, setSelectedAdditions }: AdditionsDisplayProps) => {
    if (selectedProduct.additions.length === 0) return null;
    return (
        <>
            <div className='ProductSelection-addProduct-desktop-header'>
                <span className='ProductSelection-addProduct-desktop-title'>OPCJE DODATKOWE</span>
            </div>
            <div className='NewOrder-typeElem-units'>
                {selectedProduct.additions.map((addition, index) => (
                    <Form.Group controlId={addition.name} className='ProductSelection-addProduct-checkBox ProductSelection-addProduct-additions' key={addition.name}>
                        <Form.Check
                            name={addition.name}
                            type='checkbox'
                            defaultChecked={addition.default}
                            disabled={addition.default}
                            checked={selectedAdditions[index]}
                            onChange={() => {
                                const newArr = [...selectedAdditions];
                                newArr[index] = !selectedAdditions[index];
                                setSelectedAdditions(newArr);
                            }}
                        />
                        <Form.Label>{addition.name} <span style={{ whiteSpace: 'nowrap' }}>(+{(addition.price).toFixed(2)} PLN netto,</span><span> przed rabatem</span>)</Form.Label>
                    </Form.Group>
                ))}
            </div>
            <hr />
        </>);
};

export default AdditionsDisplay;
